import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  success: {
    key: 'VideoIconStatus-success',
    defaultValue: 'Veja o vídeo',
  },
  running: {
    key: 'VideoIconStatus-running',
    defaultValue: 'Os dados estão sendo atualizados',
  },
  failed: {
    key: 'VideoIconStatus-failed',
    defaultValue: 'Falha na atualização de dados',
  },
})
